import type { EventStatus } from "@/mocks/events";

const statusConfig: Record<
  EventStatus,
  { label: string; className: string; dot?: boolean }
> = {
  live: {
    label: "直播中",
    className: "bg-accent-500/15 text-accent-400 border-accent-500/40",
    dot: true,
  },
  upcoming: {
    label: "预告",
    className: "bg-primary-500/15 text-primary-400 border-primary-500/40",
  },
  ended: {
    label: "已结束",
    className: "bg-background-200 text-foreground-500 border-background-300",
  },
};

export default function StatusBadge({ status }: { status: EventStatus }) {
  const config = statusConfig[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium whitespace-nowrap ${config.className}`}
    >
      {config.dot && (
        <span className="h-1.5 w-1.5 rounded-full bg-accent-400 animate-pulse-dot" />
      )}
      {config.label}
    </span>
  );
}